/* global angular:false */

(function () {
    "use strict";

    angular.module("vendd")
        .controller('CheckoutProductsReviewBoxController', function ($scope, $q, $element, ControlService) {
            $scope.Model = $scope.Model || {};
            $scope.Control = $scope.Control || {};

            var defered = $q.defer();

            $scope.Control.expandCombo = function (event) {
                var $el = $(event.target).hasClass('js-expand-combo') ? $(event.target) : $(event.target).parent();
                if ($el.parent().hasClass('expanded')) {
                    $el.parent().removeClass('expanded');
                    $el.removeClass('icon-arrow-up').addClass('icon-arrow-down');
                } else {
                    $el.parent().addClass('expanded');
                    $el.removeClass('icon-arrow-down').addClass('icon-arrow-up');
                }          
            };

            if (checkoutOverrides && checkoutOverrides.ProductsReviewBox && typeof checkoutOverrides.ProductsReviewBox.Extend === 'function') {
                $scope = checkoutOverrides.ProductsReviewBox.Extend($scope, $element);
            }

            angular.element($element.get(0)).ready(function () {
                if (checkoutOverrides && checkoutOverrides.Generic && typeof checkoutOverrides.Generic.InitCustomScrollbar === 'function') {
                    checkoutOverrides.Generic.InitCustomScrollbar($element);
                }               
            });
            
            ControlService.getCheckoutData("GetProductsReviewBoxData", $scope, $element).then(function (response) {
                angular.extend($scope.Model, response);
                defered.resolve();
            }, function (error) {
                throw error;
                });
        });
})();